// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  background: var(--ion-white-primary) !important;
}
ion-header ion-title {
  font-weight: 300;
  font-size: 17px;
  line-height: 25.5px;
}

* {
  color: var(--ion-dark-tertiary);
}

ion-card {
  background: var(--ion-white-primary);
}

div {
  width: 80vw;
  margin: 0 auto;
  padding: 2vw;
  background: var(--ion-white-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/aboutus/aboutus.page.scss"],"names":[],"mappings":"AAAA;EACC,+CAAA;AACD;AAAC;EACC,gBAAA;EACA,eAAA;EACA,mBAAA;AAEF;;AAEA;EACC,+BAAA;AACD;;AACA;EACC,oCAAA;AAED;;AAAA;EACC,WAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;AAGD","sourcesContent":["ion-header {\n\tbackground: var(--ion-white-primary) !important;\n\tion-title {\n\t\tfont-weight: 300;\n\t\tfont-size: 17px;\n\t\tline-height: 25.5px;\n\t}\n}\n\n*{\n\tcolor: var(--ion-dark-tertiary);\n}\nion-card{\n\tbackground: var(--ion-white-primary);\n}\ndiv{\n\twidth: 80vw;\n\tmargin: 0 auto;\n\tpadding: 2vw;\n\tbackground: var(--ion-white-primary);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
